// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react';
import {useSearchParams, Link, Navigate} from 'react-router-dom';
import styled from 'styled-components';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import { useAuth } from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const SuccessContainer = styled.div`
  max-width: 450px;
  margin: 50px auto;
  padding: 25px;
  border-radius: 12px;
  color: #fff;
  text-align: center;
  font-family: 'Arial', sans-serif;
`;

const StyledButton = styled.button`
  color: white;
  font-size: 16px;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
  width: 100%;
  max-width: 300px;
`;

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const {user, refreshUserData } = useAuth();

  useEffect(() => {
    // eslint-disable-next-line
    const paymentIntent = searchParams.get('payment_intent');
    const redirectStatus = searchParams.get('redirect_status');

    if (redirectStatus === 'succeeded') {
      setStatus('success');
    } else {
      setStatus('failed');
    }
    setTimeout(() => {
      refreshUserData();
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('paymentStatus.pageTitle')} />
      <SuccessContainer>
        {status === 'loading' ? (
          <h2>{t('paymentStatus.loading')}</h2>
        ) : status === 'success' ? (
          <>
            <h2>{t('paymentStatus.successTitle')}</h2>
            <p>{t('paymentStatus.successMessage')}</p>
            <Link to="/shop">
              <StyledButton>{t('paymentStatus.continueToShop')}</StyledButton>
            </Link>
          </>
        ) : (
          <>
            <h2>{t('paymentStatus.failedTitle')}</h2>
            <p>{t('paymentStatus.failedMessage')}</p>
            <Link to="/purchase">
              <StyledButton>{t('paymentStatus.backToPurchase')}</StyledButton>
            </Link>
          </>
        )}
      </SuccessContainer>
    </PageContentComponent>
  );
};

export default PaymentSuccess;
